import React from 'react';
import classNames from 'classnames';

class VideoYoutube extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			current: false,
		};

		console.log(this.props);

		this._goTo = this.props.goTo;
		this.props.addPhoto(this);
	}

	shouldComponentUpdate(nextState) {
		return nextState !== this.state;
	}

	goToThis = () =>
	{
		this._goTo(this.props.id);
	};

	getElementHtml()
	{
		return document.getElementById('photo' + this.props.id);
	}

	checkVisible()
	{
		let gallerie = document.getElementById("gallerie");
		let gallerieWidth = gallerie.offsetWidth;

		let elm = this.getElementHtml();
		if(elm)
			return Math.abs(elm.getBoundingClientRect().left + (elm.getBoundingClientRect().width / 2) - gallerieWidth / 2) < 20;

		return true;
	}

	getClassNames() {
		return classNames({
			'current': this.state.current,
			'photo': true
		});
	}

	render() {

		return (
			<div className={this.getClassNames()} id={'photo'+this.props.id} onClick={this.goToThis}>
				<div className="wrap">
					<div className="wrap">
						<iframe width="560" height="315" src={this.props.data.src} frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								title={this.props.data.titre}
								allowFullScreen/>
						<h3>{this.props.data.titre}</h3>
					</div>
				</div>
			</div>
		);
	}
}

export default VideoYoutube;



// WEBPACK FOOTER //
// ./src/components/VideoYoutube.js